import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { FlexboxGrid, Button, ButtonToolbar } from 'rsuite';
import { get, map, reduce, values } from 'lodash/fp';
import { getAll as getItemsAndPackagesSkusResult } from '../../../../../redux/Inventory/selectors/reports/items-and-packages-skus';
import { getItemsAndPackagesSkusSearchQuery } from '../../../../../redux/Inventory/selectors/components/reports/items-and-packages-skus';
import ReportTemplateFormModal from '../../../../../containers/ReportTemplateFormModal';
import ClientExportButton from '../../../../../components/ClientExportCsvButton';
import { ITEMS_AND_PACKAGES_SKUS } from '../../../../../helpers/ReportTemplateTypes';
import {
  ItemType,
  PackageType
} from '../../../../../constants/inventory/InventoryTypes';
import SearchDetails from '../../../../../components/inventory/reports/SearchDetails';
import tableColumns from '../../../../../components/inventory/reports/ItemsAndPackagesSkusList/columns';

const TypeLabels = {
  [ItemType]: 'Item',
  [PackageType]: 'Package'
};

export default function ResultHeader() {
  const [
    showReportTemplateFormModal,
    setShowReportTemplateFormModal
  ] = useState(false);
  const searchQuery = useSelector(getItemsAndPackagesSkusSearchQuery);
  const searchResult = useSelector(getItemsAndPackagesSkusResult);

  const { itemType } = searchQuery;

  const searchDetails = itemType
    ? [
        {
          label: 'Type',
          value: TypeLabels[itemType]
        }
      ]
    : [];

  const exportHeaderData = [
    {
      label: 'As of Date',
      value: moment().format('LLL')
    },
    ...searchDetails
  ];

  const exportColumns = map('label', values(tableColumns));
  const exportData = map(
    row =>
      reduce(
        (rowData, { dataKey }) => [
          ...rowData,
          dataKey === 'item.itemType'
            ? TypeLabels[get(dataKey, row)]
            : get(dataKey, row)
        ],
        [],
        tableColumns
      ),
    searchResult
  );

  const handleOpenReportTemplateFormModal = () => {
    setShowReportTemplateFormModal(true);
  };

  const handleCloseReportTemplateFormModal = () => {
    setShowReportTemplateFormModal(false);
  };

  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={19}>
        <SearchDetails data={searchDetails} itemWidth="100%" />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={5}>
        <ButtonToolbar style={{ textAlign: 'right' }}>
          <Button
            appearance="ghost"
            onClick={handleOpenReportTemplateFormModal}
          >
            Save Preset
          </Button>
          <ClientExportButton
            filename={`inventory_skus_${moment().format('YMMDD')}`}
            headerData={exportHeaderData}
            columns={exportColumns}
            data={exportData}
          />
        </ButtonToolbar>
        <ReportTemplateFormModal
          fileType={ITEMS_AND_PACKAGES_SKUS}
          file={searchQuery}
          show={showReportTemplateFormModal}
          onSubmitted={handleCloseReportTemplateFormModal}
          handleClose={handleCloseReportTemplateFormModal}
        />
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
}
